import e from'react';var o=typeof window>"u",f=o?e.useEffect:e.useLayoutEffect;export{f as a};